"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("./Text"));

var _LoadingShimmer = _interopRequireDefault(require("./LoadingShimmer"));

var _Map = _interopRequireDefault(require("./Map"));

var _Button = _interopRequireDefault(require("./Button"));

var _Box = _interopRequireDefault(require("./Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Skeleton = function Skeleton(props) {
  return _react.default.createElement(_LoadingShimmer.default, (0, _tslib.__assign)({}, props));
};

Skeleton.displayName = 'Skeleton';
Skeleton.Text = _Text.default;
Skeleton.Button = _Button.default;
Skeleton.Map = _Map.default;
Skeleton.Box = _Box.default;
var _default = Skeleton;
exports.default = _default;